import script from "./ArchiveSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArchiveSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./ArchiveSwitch.vue?vue&type=style&index=0&id=6f65ca36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f65ca36"]])

export default __exports__